<template>
  <div>
    <v-row class="mt-5">
      <v-btn v-if="!createMode" left color="green lighten-2" dark fab class="mt-7 ml-8" @click="createMode = true">
        <v-icon>mdi-plus</v-icon>
      </v-btn>
      <v-spacer />
    </v-row>
    <v-row v-if="notes.length > 0 || createMode">
      <v-col class="pt-0">
        <v-timeline dense class="pt-0">
          <v-timeline-item color="green" v-if="createMode">
            <v-card class="elevation-2">
              <v-card-title class="text-caption"></v-card-title>
              <v-card-text>
                <v-row class="pt-1">
                  <v-col>
                    <p>
                      <v-textarea v-model="newNote.content" dense outlined></v-textarea>
                    </p>
                  </v-col>
                </v-row>
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn dark small color="green" @click="onSaveNote(newNote)">Sauvegarder</v-btn>
                <v-btn dark small color="orange" @click="createMode = false" text>Annuler</v-btn>
              </v-card-actions>
            </v-card>
          </v-timeline-item>
          <div v-for="note in notes" :key="note.id" v-if="notes.length > 0">
            <v-timeline-item :color="getColorFromUsernameHashFromList(note.user_name)">
              <v-card class="elevation-2">
                <v-card-title class="text-caption text--secondary">
                  <div>{{ note.user_name }}</div>
                </v-card-title>
                <v-card-text>
                  <v-row class="pt-1">
                    <v-col>
                      <p v-if="editMode === note.id">
                        <v-textarea v-model="note.content" dense outlined></v-textarea>
                      </p>
                      <p class="text-body-1 text--primary" v-else>{{ note.content }}</p>
                    </v-col>
                  </v-row>
                </v-card-text>
                <v-card-actions class="mx-2">
                  <span class="text-caption text--secondary">{{ note.updated_at | dateToHuman }} {{ isEdited(note) }}</span>
                  <v-spacer></v-spacer>
                  <v-btn v-if="editMode === note.id" dark small color="green" @click="onSaveNote(note)">
                    Sauvegarder
                  </v-btn>
                  <v-btn v-if="editMode === note.id" dark small color="orange" @click="editMode = null" text>
                    Annuler
                  </v-btn>
                  <v-btn v-if="editMode === note.id" dark small color="red" @click="onDeleteNote(note)" text>
                    Effacer
                  </v-btn>
                  <v-btn v-if="modifyEnabledForNote(note)" small color="green" @click="setEditMode(note.id)" text>
                    Modifier
                  </v-btn>
                </v-card-actions>
              </v-card>
            </v-timeline-item>
          </div>
        </v-timeline>
      </v-col>
    </v-row>
    <v-row v-else>
      <v-col>
        <v-card class="elevation-1">
          <v-card-title class="text-caption">Aucune note</v-card-title>
        </v-card>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import Note from "@/models/Note"
import ConnectedUser from "@/models/ConnectedUser"

export default {
  async mounted() {
    await Note.getAllStudentCourseNotes(this.student_course_id)
  },
  props: ["student_course_id"],
  watch: {
    async student_course_id(newId) {
      if (newId) {
        await Note.getAllStudentCourseNotes(newId)
      }
    },
  },
  data() {
    return {
      editMode: false,
      createMode: false,
      newNote: {
        title: "",
        content: "",
      },
    }
  },
  computed: {
    notes() {
      return Note.query()
        .where("student_course_id", this.student_course_id)
        .orderBy("created_at", "desc")
        .all()
    },
    connectedUser() {
      return ConnectedUser.query().first()
    },
  },
  methods: {
    setEditMode(noteId) {
      this.editMode = noteId // Set the clicked note to edit mode
    },
    async onSaveNote(note) {
      if (note.id) {
        await Note.updateOne(note.id, {
          content: note.content,
        })
      } else {
        await Note.createOne({
          student_course_id: this.student_course_id,
          content: note.content,
        })
      }
      this.editMode = null
      this.createMode = false
      this.newNote.content = ""
      await this.refreshNotes()
    },
    async onDeleteNote(note) {
      await Note.deleteOne(note.id)
      this.editMode = null
      await this.refreshNotes()
    },
    async refreshNotes() {
      await Note.getAll()
    },
    getColorFromUsernameHashFromList(username) {
      const colors = [
        "green",
        "blue",
        "red",
        "orange",
        "purple",
        "pink",
        "cyan",
        "teal",
        "indigo",
        "brown",
      ]
      const hash = username
        .split("")
        .reduce((acc, char) => acc + char.charCodeAt(0), 0)

      return colors[hash % colors.length]
    },
    modifyEnabledForNote(note) {
      if (this.editMode === note.id) {
        return false
      }
      if (this.connectedUser.name !== note.user_name) {
        return false
      }
      return true
    },
    isEdited(note) {
      if (note.created_at === note.updated_at) {
        return ""
      }
      return " (modifié)"
    },
  },
}
</script>
